/*
 *		Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .directive('accMultiSelectedNodesLinkActions', [
        'template',
        '$translate',
        (
            template,
            $translate
        ) => ({
            scope: {
                selectedNodes: '='
            },
            templateUrl: template('nodes/multi_select/_selected_nodes_link_actions'),
            controller: [
                '$scope',
                ($scope) => {

                    $scope.$watchCollection('selectedNodes', () => _updateSummary());

                    $scope.canBeRevoked = () => $scope.selectedNodes.every((node) => !node.expired);

                    $scope.revokeAll = () =>
                        NodeShareLink.removeAll({ node_uuid: $scope.node.uuid })
                            .then(() => $scope.linksTable.reload());

                    $scope.close = () => $scope.$parent.resetMultiSelect();

                    const _updateSummary = () => $scope.selectionCountSummary = $translate.instant(
                        'selected_nodes_multi_select_files',
                        { COUNT: $scope.selectedNodes.length },
                        'messageformat'
                    );
                }
            ]
        })
    ]);
